import React from "react"
import { TbCalendarTime } from "react-icons/tb"
import { FaMapMarkerAlt, FaMoneyBill, FaWifi } from "react-icons/fa"
import { FaWheelchair, FaRestroom, FaPowerOff } from "react-icons/fa6"
import { MdAirlineSeatReclineExtra } from "react-icons/md"
import { HamiltonData } from "./schedule"
import { HamiltonLocations } from "./pickup-locations"

const HamiltonMeta = {
  header: {
    title: "Hamilton Airport Shuttle Service To/From Toronto Pearson",
    subtitle: "Affordable, reliable, non-stop daily bus service for Air Canada passengers",
    description: "Looking for a reliable and affordable airport shuttle from Hamilton International Airport (YHM) to Toronto Pearson International Airport (YYZ)? Landline offers comfortable, hassle-free transportation with multiple daily departures, ensuring you get to and from your Air Canada flights on time. Our premium motorcoaches provide spacious seating, free onboard Wi-Fi, in-seat power outlets to charge your devices, an onboard bathroom for your convenience, and a stress-free alternative to driving or paying expensive YYZ parking fees.",
    book: false
  },
  seo: {
    title: "Landline Airport Bus from Hamilton (YHM) to Toronto Pearson (YYZ) | Schedule & Parking Info",
    description: "Find everything you need for your Landline motorcoach trip from Hamilton International Airport (YHM) to Toronto Pearson International Airport (YYZ)—daily schedule, parking info, pickup location, and exclusive Air Canada passenger service details."
  },
  titles: {
    schedule: "Schedule",
    fares: "Fares",
    amenities: "Amenities",
  }
}

const WaterlooMeta = {
  header: {
    title: "Kitchener-Waterloo Airport Shuttle Service To/From Toronto Pearson",
    subtitle: "Affordable, reliable, non-stop daily bus service for Air Canada passengers",
    description: "Looking for a reliable and affordable airport shuttle from Region of Waterloo International Airport (YKF) to Toronto Pearson International Airport (YYZ)? Landline offers comfortable, hassle-free transportation with multiple daily departures, ensuring you get to and from your flights on time. Our premium motorcoaches provide spacious seating, free onboard Wi-Fi, in-seat power outlets to charge your devices, an onboard bathroom for your convenience, and a stress-free alternative to driving or paying expensive YYZ parking fees.",
    book: false
  },
  seo: {
    title: "Landline Airport Shuttle from Kitchener-Waterloo (YKF) to Toronto Pearson (YYZ) | Schedule & Parking Info",
    description: "Plan your trip with ease—view Landline’s daily motorcoach schedule from Region of Waterloo International Airport (YKF) to Toronto Pearson International Airport (YYZ). Get parking details, pickup location, and exclusive service info for Air Canada passengers."
  },
  titles: {
    schedule: "Schedule",
    fares: "Fares",
    amenities: "Amenities",
  }
}

const HamiltonFares = {
  titles: ["Location", "Adults", <p>Child<br /><small>(12 & Under)</small></p>, "Air Canada Vacations"],
  data: [
    ["Hamilton International Airport (YHM)", "$49 CAD", "FREE", "$40 CAD"],
  ],
}

const WaterlooFares = {
  titles: ["Location", "Adults", <p>Child<br /><small>(12 & Under)</small></p>, "Air Canada Vacations"],
  data: [
    ["Region of Waterloo International Airport (YKF)", "$49 CAD", "FREE", "$40 CAD"],
  ],
}

const NavigationItems = [
  {
    icon: <TbCalendarTime />,
    title: "Schedule",
    scrollTo: "schedule",
  },
  {
    icon: <FaMapMarkerAlt />,
    title: "Pickup Locations",
    scrollTo: "pickup-locations",
  },
  {
    icon: <FaMapMarkerAlt />,
    title: "Drop-Off Locations",
    scrollTo: "pickup-locations",
  },
  {
    icon: <FaMoneyBill />,
    title: "Fares",
    scrollTo: "fares",
  },
  {
    icon: <FaWifi />,
    title: "Amenities",
    scrollTo: "amenities",
  },
]

const AmenitiesList = [
  {
    icon: <FaWifi />,
    title: <p>Complimentary <br />Wi-Fi & Entertainment</p>,
  },
  {
    icon: <MdAirlineSeatReclineExtra />,
    title: "Reclining Leather Seats",
  },
  {
    icon: <FaPowerOff />,
    title: "In-seat Power Outlets",
  },
  {
    icon: <FaRestroom />,
    title: "Onboard Restroom",
  },
  {
    icon: <FaWheelchair />,
    title: "Handicap Accessibility",
  },
]

const TravelingData = {
  title: "Traveling With Air Canada Vacations?",
  subtitle: "20% OFF",
  text: <>
    <p>
      Book directly with Landline and save 20% on your airport shuttle to/from Toronto Pearson
      (YYZ) as an Air Canada Vacations passenger.{" "}
    </p>
    <p>
      Contact our team by texting or calling <a href="tel:+12494920941">+1 (249) 492-0941</a> to get your exclusive discount
      code now.
    </p></>
}

const English = {
  meta: HamiltonMeta,
  data: HamiltonData,
  fares: HamiltonFares,
  navigation: NavigationItems,
  traveling: TravelingData,
  amenities: AmenitiesList,
  locations: HamiltonLocations,
  english: true,
  french: false,
}

export {
  HamiltonMeta,
  WaterlooMeta,
  HamiltonFares,
  WaterlooFares,
  NavigationItems,
  TravelingData,
  AmenitiesList,
  English
}